export default "__VITE_ASSET__ccf85e63__"